module.exports = __webpack_public_path__ + "img/04：GT-2.e0cebadf.jpg";